export default __webpack_public_path__ + "img/626b84a3a64f00575f0ed5e81e4de91d.png";